// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.piano {
  display: flex;
  flex-direction: row;
  overflow: auto;
  flex-grow: 1;
}

.piano .keys {
  flex: 1 1 auto;
}

.piano .control-panel {
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;
  align-self: stretch;
  background-color: #444;
  border-radius: 3px;
  align-items: stretch;
}

.piano .control-panel .octave-button {
  height: 100%;
}

.piano .control-panel button {
  width: 24px;
  height: 100%;
  flex: 1;
  align-self: stretch;
}
`, "",{"version":3,"sources":["webpack://./src/components/piano/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,OAAO;EACP,mBAAmB;AACrB","sourcesContent":[".piano {\n  display: flex;\n  flex-direction: row;\n  overflow: auto;\n  flex-grow: 1;\n}\n\n.piano .keys {\n  flex: 1 1 auto;\n}\n\n.piano .control-panel {\n  display: flex;\n  flex-direction: column;\n  flex: 0 1 auto;\n  align-self: stretch;\n  background-color: #444;\n  border-radius: 3px;\n  align-items: stretch;\n}\n\n.piano .control-panel .octave-button {\n  height: 100%;\n}\n\n.piano .control-panel button {\n  width: 24px;\n  height: 100%;\n  flex: 1;\n  align-self: stretch;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
